export const openAI_EndpointTemplate =
  "https://api.openai.com/v1/chat/completions";

export const openAI_headerTemplate = `{
  "Content-Type": "application/json",
  "Authorization": "Bearer {{API-KEY}}"
}`;

export const openAI_bodyTemplate = `{
  "model": "gpt-4o",
  "temperature": 1,
  "max_tokens": 8000,
  "top_p": 1,
  "frequency_penalty": 0,
  "presence_penalty": 0,
  "stream": true,
  "stream_options": {"include_usage": true}
}`;

export const openAI_inputPricePerMillion = 2.5;
export const openAI_outputPricePerMillion = 10.0;

export const azure_EndpointTemplate =
  "hhttps://<<replace with your deployment>>.openai.azure.com/openai/deployments/<<replace with model region, eg: GPT4o-US2>>/chat/completions?<<replace: eg. api-version=2024-02-15-preview>>";

export const azure_headerTemplate = `{
  "Content-Type": "application/json",
  "api-key": "{{API-KEY}}"
}`;

export const azure_bodyTemplate = `{
  "model": "gpt-4o",
  "temperature": 1,
  "max_tokens": 4000,
  "top_p": 1,
  "frequency_penalty": 0,
  "presence_penalty": 0,
  "stream": true
}`;

export const azure_inputPricePerMillion = 5.0;
export const azure_outputPricePerMillion = 15.0;

export const anthropic_EndpointTemplate =
  "https://api.anthropic.com/v1/messages";

export const anthropic_headerTemplate = `{
  "anthropic-version": "2023-06-01" ,
  "Content-Type": "application/json",
  "x-api-key": "{{API-KEY}}"
}`;

export const anthropic_bodyTemplate = `{
  "model": "claude-3-7-sonnet-latest",
  "max_tokens": 8000,
  "stream": true
}`;

export const anthropic_inputPricePerMillion = 3.0;
export const anthropic_outputPricePerMillion = 15.0;

export const chaos_EndpointTemplate = "https://llmasaservice.io";

export const chaos_headerTemplate = `{
}`;

export const chaos_bodyTemplate = `{
}`;

//gemini-2.0-flash   gemini-2.0-flash-lite
export const google_EndpointTemplate =
  "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:streamGenerateContent?alt=sse&key={{API-KEY}}";

export const google_headerTemplate = `{
  "Content-Type": "application/json"
}`;

export const google_bodyTemplate = `{
}`;

export const google_inputPricePerMillion = 0.1;
export const google_outputPricePerMillion = 0.4;

export const bedrock_EndpointTemplate = "";

export const bedrock_headerTemplate = `{
  "Content-Type": "application/json"
}`;

export const bedrock_bodyTemplate = `{
"region":"us-east-1",
"modelId":"anthropic.claude-v2",
"stream": true,
"inferenceConfig": { 
     "maxTokens": 4000, 
     "temperature": 1, 
     "topP": 1 
  }
}`;

export const mistral_EndpointTemplate =
  "https://api.mistral.ai/v1/chat/completions";
export const mistral_headerTemplate = `{
  "Content-Type": "application/json",
  "Authorization": "Bearer {{API-KEY}}"
}`;
export const mistral_bodyTemplate = `{
    "model": "mistral-large-latest",
    "max_tokens": 4000,
    "stream": true
}`;
export const mistral_inputPricePerMillion = 3.0;
export const mistral_outputPricePerMillion = 9.0;

export const ollama_EndpointTemplate = "http:/[your ollama server:11434]/api/chat";
export const ollama_headerTemplate = `{
  "Content-Type": "application/json",
  "Authorization": "Bearer {{API-KEY}}"
}`;
export const ollama_bodyTemplate = `{
  "model": "deepseek-r1:1.5b",
  "stream": true
}`;
export const ollama_inputPricePerMillion = 0.0;
export const ollama_outputPricePerMillion = 0.0;